module.exports = __webpack_public_path__ + "static/Sprite_1-9b557e6483fc3e83614f54dcbe074a6d.jpg";